import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import backgroundImage from '../../../../assets/images/wip.jpg';
import { RoutePath } from '../../../routes';
import divButtonStyles from '../../buttons/divButton/divButton.scss';
import styles from './homeBackground.scss';

type Props = {
  id: string;
};

const HomeBackground: React.FC<Props> = (props) => {
  return (
    <div id={props.id} data-testid={props.id} className={styles['home-hero']}>
      <div className={styles['image-container']}>
        {/* <img className={styles['image']} src={backgroundImage} alt="Background Image" /> */}
        <div className={styles['image']} style={{ backgroundImage: `url(${backgroundImage})` }} />
      </div>

      <div className={styles['content-container']}>
        <p>Hi, my name is Khanh.</p>
        <h1>React Developer</h1>

        <div className={styles['text']}>Apologies for the lack of content here right now.</div>
        <div className={styles['text']}>Things should be back up soon, please call again!</div>

        {/* <div className={styles['buttons']}>
          <Link to={RoutePath.Projects} className={divButtonStyles['btn']}>
            Projects
          </Link>

          <Link to={RoutePath.Contact} className={classNames(divButtonStyles['btn'], divButtonStyles['btn-light'])}>
            Contact
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default HomeBackground;
